import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import {
	PromoteLoginModalSendResetPasswordLink,
	type PromoteLoginModalSendResetPasswordLinkMutation,
	type PromoteLoginModalSendResetPasswordLinkMutationVariables,
} from './sendResetPasswordLink.graphql';

export async function sendResetPasswordLink(
	input: PromoteLoginModalSendResetPasswordLinkMutationVariables,
	{ gql: { fetch } }: UtilityContext,
): Promise<boolean> {
	const { data, errors } = await fetch<
		PromoteLoginModalSendResetPasswordLinkMutation,
		PromoteLoginModalSendResetPasswordLinkMutationVariables
	>({
		query: PromoteLoginModalSendResetPasswordLink,
		variables: input,
		rejectOnError: false,
	});

	if (errors) throw new Error(JSON.stringify(errors));

	return !!data?.sendResetPasswordLink?.success;
}
